import {APIEventSystem} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {TopTrainView} from "./TopTrainView";
import {SideTrainView} from "./SideTrainView";
import {IFsSymbolData} from "../../../symbols/freespin/FreespinSymbol";
import {FreespinTrainView} from "./FreespinTrainView";

export class FreespinTrainModel{
    private _reelId: number;
    private _reelView: FreespinTrainView;
    public readonly events: APIEventSystem | undefined;

    constructor(id: number) {
        this._reelId = id;
        if(id === -1){
            this._reelView= new TopTrainView(id);
        }else if(id === 6){
            this._reelView = new SideTrainView(id);
        }
    }

    public init(symbols: IFsSymbolData[]): void {
        this._reelView.initReel(symbols);
    }

    public get reelView():FreespinTrainView{
        return this._reelView;
    }
}